import PlatformUpdatesAPI from '../../api/platformUpdates';

const state = {
    records: [],
    unreadCount: 0,
    meta: {},
    uiFlags: {
        isFetching: false,
    },
};

const getters = {
    getRecords: $state => $state.records,
    getUnreadCount: $state => $state.unreadCount,
    getMeta: $state => $state.meta,
    getUIFlags: $state => $state.uiFlags,
};

const actions = {
    async get({ commit }, page = 1) {
        commit('setUIFlag', { isFetching: true });
        try {
            const { data } = await PlatformUpdatesAPI.getUpdates(page);
            commit('setRecords', data.data || []);
            commit('setMeta', data.meta || {});
        } catch (error) {
            console.error('[PlatformUpdates] Error fetching updates:', error);
        } finally {
            commit('setUIFlag', { isFetching: false });
        }
    },

    async fetchUnreadCount({ commit }) {
        try {
            const { data } = await PlatformUpdatesAPI.getUnreadCount();
            commit('setUnreadCount', data.unread_count);
        } catch (error) {
            // handle silently
        }
    },

    async markAllRead({ commit }) {
        try {
            await PlatformUpdatesAPI.markAllRead();
            commit('setUnreadCount', 0);
        } catch (error) {
            // handle silently
        }
    },
};

const mutations = {
    setRecords($state, records) {
        $state.records = records;
    },
    setUnreadCount($state, count) {
        $state.unreadCount = count;
    },
    setMeta($state, meta) {
        $state.meta = meta;
    },
    setUIFlag($state, flag) {
        $state.uiFlags = { ...$state.uiFlags, ...flag };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
